import { render, staticRenderFns } from "./KeywordRule.vue?vue&type=template&id=be5165e0&scoped=true"
import script from "./KeywordRule.vue?vue&type=script&lang=js"
export * from "./KeywordRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5165e0",
  null
  
)

export default component.exports